export default "__VITE_ASSET__7rGdbt$I__"